import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private baseUrl = environment.apiResrURL;
  private adminUrl = `${this.baseUrl}/sgi-administracion`;

  public current_monto = environment.montoMay2 ?? 200000;

  constructor(private http: HttpClient) {
    this.consultarMonto().subscribe({
      next: (resp) => {
        if (resp?.data?.monto) {
          this.current_monto = resp.data.monto;
        }
      },
      error: () => {},
    });
  }

  public consultarMonto(): Observable<any> {
    return this.http.get<any>(`${this.adminUrl}/consultarMonto`);
  }

  public consultarEstadoTienda(): Observable<any> {
    return this.http.get<any>(`${this.adminUrl}/estadoTienda`);
  }

  public consultarZonas(): Observable<any> {
    return this.http.get<any>(`${this.adminUrl}/zonas`);
  }
}
